import ApplesPears from "./illustrations/food/apples-pears"
import Beef from "./illustrations/food/beef"
import Bird from "./illustrations/food/bird"
import Bread from "./illustrations/food/bread"
import Cheese from "./illustrations/food/cheese"
import Eggs from "./illustrations/food/eggs"
import Margarine from "./illustrations/food/margarine"
import Milk from "./illustrations/food/milk"
import Pasta from "./illustrations/food/pasta"
import Pork from "./illustrations/food/pork"
import Potatoes from "./illustrations/food/potatoes"

import FertilizerLarge from "./illustrations/fertilizer-large"
import FertilizerMedium from "./illustrations/fertilizer-medium"
import FertilizerSmall from "./illustrations/fertilizer-small"
import PesticidesLarge from "./illustrations/pesticides-large"
import PesticidesMedium from "./illustrations/pesticides-medium"
import PesticidesSmall from "./illustrations/pesticides-small"
import UnsprayedGroundLarge from "./illustrations/unsprayed-ground-large"
import UnsprayedGroundMedium from "./illustrations/unsprayed-ground-medium"
import UnsprayedGroundSmall from "./illustrations/unsprayed-ground-small"

export const peopleData = [
  { label: "Jag", value: 1 },
  { label: "Familj", value: 4 },
  { label: "Skola", value: 225 },
  { label: "Stad", value: 10000 },
  { label: "Sverige", value: 10000000 }
]

export const slidesData = [
  {
    label: "Bekämpningsmedel",
    title: "Bekämpningsmedel",
    unit: "liter",
    unitAlternative: null,
    unitLimit: null,
    unitOperator: null,
    total: 0,
    illustration: {
      small: <PesticidesSmall className="w-full h-full" />,
      medium: <PesticidesMedium className="w-full h-full" />,
      large: <PesticidesLarge className="w-full h-full" />
    },
    info: (
      <div>
        <h4 className="mb-4">Bekämpningsmedel</h4>
        <p>
          Eko använder inte naturfrämmande kemiska bekämpningsmedel, alltså
          medel som inte förekommer naturligt i naturen. Siffrorna visar hur
          mycket brukslösning, dvs utspädd lösning i liter, som stoppas när du
          byter till ekologiskt.
        </p>
      </div>
    )
  },
  {
    label: "Konstgödsel",
    title: "Konstgödsel",
    unit: "kg",
    unitAlternative: null,
    unitLimit: null,
    unitOperator: null,
    total: 0,
    illustration: {
      small: <FertilizerSmall className="w-full h-full" />,
      medium: <FertilizerMedium className="w-full h-full" />,
      large: <FertilizerLarge className="w-full h-full" />
    },
    info: (
      <div>
        <h4 className="mb-4">Konstgödsel</h4>
        <p>
          Eko skippar konstgödsel och jobbar istället med kretslopp och gödsel
          från djuren. Statistiken visar hur mycket konstgödsel i kilo som inte
          används när du byter till ekologiskt.
        </p>
      </div>
    )
  },
  {
    label: "Areal obesprutad",
    title: "Obesprutad mark",
    unit: "m2",
    unitAlternative: "ha",
    unitLimit: 10000,
    unitOperator: "/",
    total: 0,
    illustration: {
      small: <UnsprayedGroundSmall className="w-full h-full" />,
      medium: <UnsprayedGroundMedium className="w-full h-full" />,
      large: <UnsprayedGroundLarge className="w-full h-full" />
    },
    info: (
      <div>
        <h4 className="mb-4">Obesprutad mark</h4>
        <p>
          Siffrorna visar hur stor yta jordbruksmark som inte besprutas med
          naturfrämmande bekämpningsmedel genom dina val. Dessa medel används
          inte i ekologisk produktion.
        </p>
      </div>
    )
  }
]

export const foodData = [
  {
    label: "Bröd",
    icon: <Bread className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 111.2,
        valueSchool: 2250.6,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 5.84,
        valueSchool: 118.1,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 6.64, valueSchool: 134.2, unit: "kg" }
    ]
  },
  {
    label: "Pasta",
    icon: <Pasta className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 30.1,
        valueSchool: 2663.1,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 1.58,
        valueSchool: 96.9,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 1.8, valueSchool: 158.9, unit: "kg" }
    ]
  },
  {
    label: "Potatis",
    icon: <Potatoes className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 23.6,
        valueSchool: 1134.1,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 2.31,
        valueSchool: 110.9,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 2.79, valueSchool: 133.9, unit: "kg" }
    ]
  },
  {
    label: "Äpplen och päron",
    icon: <ApplesPears className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 15.7,
        valueSchool: 1170.3,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 1.4,
        valueSchool: 104.1,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 0.57, valueSchool: 42.6, unit: "kg" }
    ]
  },
  {
    label: "Mjölk och grädde",
    icon: <Milk className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 219.7,
        valueSchool: 16868.2,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 4.2,
        valueSchool: 318.9,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 8.1, valueSchool: 624.2, unit: "kg" }
    ]
  },
  {
    label: "Hårdost",
    icon: <Cheese className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 330.3,
        valueSchool: 4867.1,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 6.2,
        valueSchool: 92,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 12.2, valueSchool: 180.1, unit: "kg" }
    ]
  },
  {
    label: "Smör och margarin",
    icon: <Margarine className="mr-1 w-8 h-8" />,
    data: [
      { label: "Areal obesprutad", value: 89, valueSchool: 1909.7, unit: "m2" },
      {
        label: "Bekämpningsmedel",
        value: 2.67,
        valueSchool: 96.5,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 2.86, valueSchool: 43.6, unit: "kg" }
    ]
  },
  {
    label: "Ägg",
    icon: <Eggs className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 119.8,
        valueSchool: 555.5,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 3.9,
        valueSchool: 18.07,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 3.3, valueSchool: 15.4, unit: "kg" }
    ]
  },
  {
    label: "Fågel",
    icon: <Bird className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 311.7,
        valueSchool: 12355.8,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 9.7,
        valueSchool: 386.3,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 8.1, valueSchool: 322.8, unit: "kg" }
    ]
  },
  {
    label: "Griskött",
    icon: <Pork className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 303.2,
        valueSchool: 10083.2,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 9.6,
        valueSchool: 319.8,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 9.8, valueSchool: 324.5, unit: "kg" }
    ]
  },
  {
    label: "Nötkött",
    icon: <Beef className="mr-1 w-8 h-8" />,
    data: [
      {
        label: "Areal obesprutad",
        value: 657.6,
        valueSchool: 49027.6,
        unit: "m2"
      },
      {
        label: "Bekämpningsmedel",
        value: 17.4,
        valueSchool: 1296,
        unit: "liter"
      },
      { label: "Konstgödsel", value: 23, valueSchool: 1717.4, unit: "kg" }
    ]
  }
]
